import { useMutation } from 'react-query';
import request from '../../../../../../helpers/request';
import { fetchShutdownsThunk } from '../../../../shared/model/actions';
import { useDispatch } from 'react-redux';

const changeNotifyTo = async ({ shutdownId, data }) => {
  const res = await request.put(
    `/Alert/notify/${shutdownId}`,
    data,
    'Не удалось сохранить список тех, кому отправить уведомление',
    'Error'
  );

  return res;
};

export const useShutdownNotifyToChange = (options = {}) => {
  const dispatch = useDispatch();

  const changeMutation = useMutation(changeNotifyTo, {
    ...options,
    onSuccess: async (res, { shutdownId }) => {
      if (res !== 'Error') {
        dispatch(fetchShutdownsThunk());
      }
    },
  });

  return {
    change: changeMutation.mutateAsync,
    loading: changeMutation.isLoading,
  };
};
